import React from 'react'
import { TablaMisUsuarios } from '../../Components/Components'

export const MisUsuarios = ({initState,updateState,data,load,reload}) => {
  return (
    <React.Fragment>
      <TablaMisUsuarios initState={initState} updateState={updateState} data={data} load={load} reload={reload}/>
    </React.Fragment>
  )
}